import { useContext, useEffect, useState } from 'react'
import { Favorites } from '../Components/Favorites'
import { StoreContextMain } from '../../Context/StoreContextMain'
import { prefetchData } from '../../Helpers'
import { CardFavorite } from '../../Components/Cards/CardFavorite'

export const WishList = () => {

    const { myWish } = useContext(StoreContextMain)

    const [wishList, setWishList] = useState([])
    const [deleteItem, setDeleteItem] = useState(null)

    useEffect(() => {

        if ( myWish.length > 0 ) {
            getWishList(myWish)
        }

        return () => {
            setWishList([])
        }

    }, [myWish, deleteItem])

    const getWishList = async (myWishId) => {
        try {
            const results = await prefetchData(`wishlist_items/`, {"wishlist": myWishId})
            setWishList(results?.results)
            return results
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className='container '>
            <div className='row'>
                {/* <div className='col-12 col-md-4 order-md-0 order-1'>
                    <GridCards />
                </div> */}
                <div className='col col-md-4'>
                    <h3 className='text-center m-2'> Mis lista de deseos: </h3>
                    <Favorites />
                </div>
                <div className='col-12 col-md-4 '>
                    {
                        wishList?.map((item) => {
                            console.log('Item: ', item)
                            return (
                                <CardFavorite
                                    key={item?.product_id.uuid}
                                    id={item?.id}
                                    title={item?.product_id.name}
                                    image={item?.product_id.image?.image}
                                    price={item?.product_id.price}
                                    product_id={item?.product_id.uuid}
                                    setDeleteItem={setDeleteItem}
                                />
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}
